(() => {
  if (window.hcFooterInitialized) return;
  window.hcFooterInitialized = true;

  const revealContainingInformation = (target) => {
    if (!(target instanceof Element)) return;
    const information = target.closest('.hc-footer [data-hc-footer-information]');
    if (information) information.open = true;
  };

  const revealLinkedInformation = () => {
    if (!window.location.hash) return;
    let id;
    try {
      id = decodeURIComponent(window.location.hash.slice(1));
    } catch {
      return;
    }
    revealContainingInformation(document.getElementById(id));
  };

  document.addEventListener('shopify:block:select', (event) => {
    revealContainingInformation(event.target);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const information = event.target.closest('.hc-footer [data-hc-footer-information][open]');
    if (!information || information.querySelector('localization-form button[aria-expanded="true"]')) return;
    event.preventDefault();
    information.open = false;
    information.querySelector(':scope > summary')?.focus();
  });
  window.addEventListener('hashchange', revealLinkedInformation);
  revealLinkedInformation();
})();
